import * as THREE from 'three';
import { FikoObje3D } from '../../../FikoObje3D';
import { FikoSahne } from '../../../FikoSahne';


export class FikoAktivitePuntalama extends FikoObje3D {
    static SAYAC = 1;

    override type = 'FikoGrupCizim';
    readonly isGroup: true;

    public get liste(): any[] {
        return this.children;
    }

    sagButonlar?: any[] = [
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoSimilasyon.ac(this);
                // this.sahne.anaGosterim.DialogFikoSimilasyon.tiklandiIleriOynat();
            }
        }
    ];


    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Gizle / Göster",
            tiklandi: () => {
                this.visible = !this.visible;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        },
        {
            tipi: "Ayraç"
        },
        {
            simge: null,
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]

    aracCubugu: any[] = [
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoPuntalama.ac(this);
            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);
                this.sahne.anaGosterim.aktifItem = null;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]

    constructor(public override sahne?: FikoSahne, isim?: string) {
        super(sahne);
        this.name = isim;

        this.userData.FikoArayuz.agactaGorunur = true;
        this.userData.FikoArayuz.listeGoster = true;
        this.userData.FikoArayuz.simge = "./sistem/simgeler/punta.webp";

        if (!isim) {
            this.name = "FikoPuntalama." + FikoAktivitePuntalama.SAYAC;
            FikoAktivitePuntalama.SAYAC++;
        } else {
            this.name = isim;
        }

    }

    override ekle?(...objeler: FikoObje3D[]): any {
        super.add(...objeler);

        return this;
    }

}